import React, { useContext as useContextCore } from 'react'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children }) => {
  const [newUser, setNewUser] = React.useState({})
  const [error, setError] = React.useState(null)
  return <CoreProvider value={{ newUser, setNewUser, error, setError }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
